import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose, DialogTrigger } from "@/components/ui/dialog";
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { Question, X } from "@phosphor-icons/react";
import { FaqContent } from "../FaqContent";
export interface HelpDialogProps {
  isMobile: boolean;
  showFaqDialog: boolean;
  isLoading: boolean;
  isProcessingSpeech: boolean;
  onFaqDialogChange: (open: boolean) => void;
}
export function HelpDialog(t0) {
  const $ = _c(21);
  const {
    isMobile,
    showFaqDialog,
    isLoading,
    isProcessingSpeech,
    onFaqDialogChange
  } = t0;
  if (isMobile) {
    const t1 = isLoading || isProcessingSpeech;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Question className="w-5 h-5 text-muted-foreground" weight="bold" />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] !== t1) {
      t3 = <DrawerTrigger asChild={true}><Button variant="ghost" size="icon" className="shrink-0 h-11 w-11 rounded-lg hover:bg-muted" disabled={t1}>{t2}</Button></DrawerTrigger>;
      $[1] = t1;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <DrawerHeader className="text-center pb-1"><div className="mx-auto w-12 h-1 bg-muted-foreground/20 rounded-full mb-4" /><DrawerTitle className="text-xl font-semibold">{"Help & FAQ"}</DrawerTitle><DrawerDescription className="text-muted-foreground text-sm">Frequently asked questions about Vif</DrawerDescription></DrawerHeader>;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="overflow-auto max-h-[calc(80vh-140px)] rounded-xl border border-muted p-1 bg-background scrollbar-hide"><FaqContent /></div>;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <DrawerContent className="px-4 [&>div:first-child]:hidden">{t4}{t5}<DrawerFooter className="mt-2 pb-6"><div className="flex justify-end"><DrawerClose asChild={true}><Button variant="secondary" className="rounded-full px-6 h-9 w-full">Done</Button></DrawerClose></div></DrawerFooter></DrawerContent>;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    let t7;
    if ($[6] !== onFaqDialogChange || $[7] !== showFaqDialog || $[8] !== t3) {
      t7 = <Drawer open={showFaqDialog} onOpenChange={onFaqDialogChange}>{t3}{t6}</Drawer>;
      $[6] = onFaqDialogChange;
      $[7] = showFaqDialog;
      $[8] = t3;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    return t7;
  }
  const t1 = isLoading || isProcessingSpeech;
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Question className="w-5 h-5 text-muted-foreground" weight="bold" />;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1) {
    t3 = <DialogTrigger asChild={true}><Button variant="ghost" size="icon" className="shrink-0 h-11 w-11 rounded-lg hover:bg-muted" disabled={t1}>{t2}</Button></DialogTrigger>;
    $[11] = t1;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute right-4 top-4"><DialogClose asChild={true}><Button variant="ghost" size="icon" className="h-7 w-7 rounded-full bg-muted hover:bg-muted/80 focus:ring-0"><X className="w-3.5 h-3.5" weight="bold" /><span className="sr-only">Close</span></Button></DialogClose></div>;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogHeader className="pb-1 space-y-1"><DialogTitle className="text-lg font-semibold">{"Help & FAQ"}</DialogTitle><DialogDescription className="text-muted-foreground text-sm">Frequently asked questions about Vif</DialogDescription></DialogHeader>;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="overflow-auto max-h-[calc(80vh-140px)] my-3 pr-1 rounded-xl border border-muted/50 p-1 bg-background/50 scrollbar-hide"><FaqContent /></div>;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DialogContent className="sm:max-w-md rounded-2xl border shadow-lg gap-2 p-3 [&>button]:hidden">{t4}{t5}{t6}<DialogFooter className="flex items-center justify-end !mt-0 !pt-0"><DialogClose asChild={true}><Button variant="secondary" className="rounded-full px-5 h-9 w-full">Done</Button></DialogClose></DialogFooter></DialogContent>;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onFaqDialogChange || $[18] !== showFaqDialog || $[19] !== t3) {
    t8 = <Dialog open={showFaqDialog} onOpenChange={onFaqDialogChange}>{t3}{t7}</Dialog>;
    $[17] = onFaqDialogChange;
    $[18] = showFaqDialog;
    $[19] = t3;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}